module.exports = __webpack_public_path__ + "img/bg-woman-1.671c8715.png";